export const ErrorCodes = {
  USER_LOCKED_TO_LOGIN: 34,
  WRONG_CREDENTIALS: 174,
}
